export default "__VITE_ASSET__VD0W57qi__"